import Emitter from "es6-event-emitter";
import template from "./../templates/preferredViewerSwitcher.dust";
import i18n from "./../../common/dictionary";

export default class PreferredViewerSwitcher extends Emitter {
  constructor(appState, DOMContainer, type = "segmentButton", options) {
    super();
    this._appState = appState;
    this._DOMContainer = DOMContainer;
    this.type = type;
    this._options = options;
  }

  render() {
    const context = {
      i18n,
      preferredViewer: this._appState.preferredViewer,
      type: this.type,
      useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
      displayTopNavButtonlabel: this._options
        ? this._options.displayTopNavButtonlabel
        : false,
    };

    if (this._options && this._options.displayTopNavButtonlabel) {
      this._DOMContainer.classList.add("labelDisplayed");
    }

    Dust.render(template, context, (err, result) => {
      this._DOMContainer.innerHTML = result;
      this._attachListeners();
    });
  }

  ///////////////

  _attachListeners() {
    this.viewerSwitcherEl = document.getElementById("viewer-switcher");

    if (this.viewerSwitcherEl) {
      this.viewerSwitcherEl.addEventListener(
        "click",
        this._viewerSelectorClickHandler.bind(this)
      );
    }

    this._appState.on(
      "preferredViewer:changed",
      this._onPreferredViewerChanged.bind(this)
    );
  }

  _viewerSelectorClickHandler(e) {
    if (this._options && this._options.displayTopNavButtonlabel) {
      this.trigger("readingModeSwitcher:clicked", e.target.parentNode.value);
      this._appState.preferredViewer = e.target.parentNode.value;
    } else {
      this.trigger("readingModeSwitcher:clicked", e.target.value);
      this._appState.preferredViewer = e.target.value;
    }

    [].forEach.call(this.viewerSwitcherEl.children, (node) => {
      node.classList.remove("active");
    });
    if (this._options && this._options.displayTopNavButtonlabel) {
      e.target.parentNode.classList.add("active");
    } else {
      e.target.classList.add("active");
    }
  }

  _onPreferredViewerChanged(type) {
    [].forEach.call(this.viewerSwitcherEl.children, (node) => {
      node.classList.remove("active");
    });

    this.viewerSwitcherEl
      .querySelector(`[value=${type}]`)
      .classList.add("active");
  }
}



// WEBPACK FOOTER //
// ./src/common/components/preferredViewerSwitcher.js